export const PLAYERS_IN_TEAM = 6;
export const MIN_SR = 1450;
export const MAX_SR = 4200;
